// this is new obj easy-start page
// {
//       title: "Recipe App 1",
//   componentList:" ["Audio Player", "Social Media Links", "Author Contacts", "Soundcloud", "activityCardsApp.photoGallery.title'), "Talent Booking",
//   detailsList: [
//     {
//       icon: `<svg width="29" height="36" viewBox="0 0 29 36" xmlns="http://www.w3.org/2000/svg">
//       <path d="M26.3996 13.2505H26.468L28.2453 11.4048C28.4504 11.1997 28.5871 10.9263 28.5871 10.6528C28.5871 10.311 28.4504 10.0376 28.2453 9.90088L26.7414 8.32861C26.5363 8.12354 26.2629 7.98682 25.9211 7.98682C25.6477 7.98682 25.3742 8.12354 25.1691 8.32861L23.4602 10.0376C21.5461 8.46533 19.2219 7.37158 16.6926 6.96143V4.56885H18.8801C19.427 4.56885 19.9738 4.09033 19.9738 3.4751V1.2876C19.9738 0.740723 19.427 0.193848 18.8801 0.193848H10.1301C9.51484 0.262207 9.03633 0.740723 9.03633 1.2876V3.4751C9.03633 4.09033 9.51484 4.56885 10.1301 4.56885H12.3176V6.96143C5.61836 7.98682 0.491405 13.6606 0.286327 20.5649C0.0128899 28.3579 6.43867 35.1255 14.2316 35.1938C22.2297 35.3306 28.7238 28.9048 28.7238 20.9751C28.7238 18.1724 27.8352 15.5063 26.3996 13.2505ZM13.1379 26.0337C13.4113 26.0337 13.6848 26.3071 13.6848 26.5806V28.0845C13.6848 28.4263 13.4113 28.6313 13.1379 28.6313C13.1379 28.6313 13.1379 28.6997 13.1379 28.6313H7.46406C7.46406 28.6997 7.46406 28.6997 7.46406 28.6997C6.84883 28.6997 6.30195 28.1528 6.30195 27.5376V27.4692C6.50703 25.0767 7.32734 23.5044 8.96797 21.2485C10.3352 19.1978 10.8137 18.6509 10.8137 16.9419C10.8137 15.7798 10.677 15.3013 9.99336 15.3013C9.30976 15.3013 9.10469 15.7798 9.10469 16.8735V17.2153C9.10469 17.4888 8.83125 17.7622 8.55781 17.7622H6.84883C6.50703 17.7622 6.30195 17.4888 6.30195 17.2153V16.9419C6.30195 15.0278 6.84883 12.772 10.1301 12.772C13.0695 12.772 13.9582 14.5493 13.9582 16.9419C13.9582 19.4028 13.0695 20.4966 11.5656 22.5474C10.8137 23.5728 9.925 24.9399 9.78828 26.0337H13.1379ZM22.7082 24.3247C22.7082 26.7173 21.8195 28.6313 18.7434 28.6313C15.8039 28.6313 15.052 26.6489 15.052 24.3247V17.147C15.052 14.3442 16.3508 12.772 18.8801 12.772C21.4094 12.772 22.7082 14.3442 22.7082 17.0103V24.3247ZM18.8117 15.3696C18.1965 15.3696 17.923 15.9165 17.923 16.7368V24.6665C17.923 25.5552 18.1965 26.1021 18.8117 26.1021C19.4953 26.1021 19.7004 25.5552 19.7004 24.5981V16.7368C19.7004 15.9165 19.4953 15.3696 18.8117 15.3696Z" />
//       </svg>
//       `,
//       title: "Quick",
//       doc: "Create full apps in 20 mins  or more"
//     },
//     {
//       icon: `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
//       <path d="M12.9163 0.996582C6.86164 2.20752 2.01789 7.05127 0.867504 13.0454C-1.37273 24.3677 8.79914 32.7837 16.5491 31.6333C19.0316 31.2095 20.2425 28.3032 19.0921 26.063C17.6995 23.2778 19.6976 20.0688 22.7855 20.0688H27.6292C29.7484 20.0688 31.5042 18.313 31.5648 16.1333C31.5042 6.62744 22.846 -0.880371 12.9163 0.996582ZM6.37727 20.0688C5.28743 20.0688 4.43977 19.2212 4.43977 18.1313C4.43977 17.1021 5.28743 16.1938 6.37727 16.1938C7.40657 16.1938 8.31477 17.1021 8.31477 18.1313C8.31477 19.2212 7.40657 20.0688 6.37727 20.0688ZM8.31477 12.3188C7.22493 12.3188 6.37727 11.4712 6.37727 10.3813C6.37727 9.35205 7.22493 8.44385 8.31477 8.44385C9.34407 8.44385 10.2523 9.35205 10.2523 10.3813C10.2523 11.4712 9.34407 12.3188 8.31477 12.3188ZM16.0648 8.44385C14.9749 8.44385 14.1273 7.59619 14.1273 6.50635C14.1273 5.47705 14.9749 4.56885 16.0648 4.56885C17.0941 4.56885 18.0023 5.47705 18.0023 6.50635C18.0023 7.59619 17.0941 8.44385 16.0648 8.44385ZM23.8148 12.3188C22.7249 12.3188 21.8773 11.4712 21.8773 10.3813C21.8773 9.35205 22.7249 8.44385 23.8148 8.44385C24.8441 8.44385 25.7523 9.35205 25.7523 10.3813C25.7523 11.4712 24.8441 12.3188 23.8148 12.3188Z" />
//       </svg>
//       `,
//       title: "Easy",
//       doc: "No need to code. Visual editor."
//     },
//     {
//       icon: `<svg width="31" height="31" viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg">
//       <path d="M15.6248 0.359375C7.32991 0.359375 0.609203 7.08008 0.609203 15.375C0.609203 23.6699 7.32991 30.3906 15.6248 30.3906C23.9198 30.3906 30.6405 23.6699 30.6405 15.375C30.6405 7.08008 23.9198 0.359375 15.6248 0.359375ZM17.078 23.125V24.0938C17.078 24.6387 16.5936 25.0625 16.1092 25.0625H15.1405C14.5955 25.0625 14.1717 24.6387 14.1717 24.0938V23.125C13.1424 23.125 12.1737 22.7617 11.326 22.2168C10.7811 21.8535 10.7205 21.127 11.2049 20.7031L11.9315 20.0371C12.2342 19.7344 12.7186 19.6738 13.1424 19.916C13.5057 20.1582 13.869 20.2188 14.2928 20.2188H17.0174C17.744 20.2188 18.2889 19.6133 18.2889 18.8262C18.2889 18.1602 17.9256 17.6152 17.3807 17.4336L13.0213 16.1016C11.2655 15.6172 9.99397 13.8613 9.99397 11.9844C9.99397 9.62305 11.8709 7.68555 14.1717 7.625V6.65625C14.1717 6.17188 14.5955 5.6875 15.1405 5.6875H16.1092C16.5936 5.6875 17.078 6.17188 17.078 6.65625V7.68555C18.0467 7.68555 19.0155 7.98828 19.8631 8.59375C20.408 8.95703 20.4686 9.68359 19.9842 10.1074L19.2576 10.7734C18.9549 11.0762 18.4705 11.1367 18.1073 10.8945C17.6834 10.6523 17.3201 10.5312 16.8963 10.5312H14.1717C13.4451 10.5312 12.9002 11.1973 12.9002 11.9844C12.9002 12.5898 13.2635 13.1953 13.8084 13.377L18.1678 14.6484C19.9237 15.1934 21.1951 16.8887 21.1951 18.8262C21.1951 21.1875 19.3182 23.125 17.078 23.125Z" />
//       </svg>
//       `,
//       title: "Smart",
//       doc: "Monetize your app in few clicks."
//     }
//   ],
//   description: `
//   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
//   `,
//   color: '#fff',
//   qrCodeImg: "/static/images/v3/qrcode-app-wallpapers.webp",
//   backgroundColor: "#666870",
//   backgroundUrl: "/static/images/v3/background-app-wallpapersjpg",
//   previewUrl: "/static/images/v3/1241166.png",
//   googlePlayUrl: "#googlePlayUrl",
//   layoutsId: 2809966
// },

export default {
  content: {
    wallpapers: [
      {
        isShowBtn: true,
        title: "easyStart.wallpapers.wallpaperium",
        description: "easyStart.one-of-the-most-popular-apps-upload",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 3000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-wallpapers.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-wallpapers-wallpaperium.webp",
        backgroundColor: "#2B2E40",
        color: '#fff',
        previewUrl: "/static/images/v3/1110077.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1CySrUvMr0pi0Ok48APOZJM0Jexs-mQja/view?usp=sharing",
        layoutsId: 2809876
      },
      {
        isShowBtn: true,
        title: "easyStart.wallpapers.kawaii-wallpapers",
        description: "easyStart.one-of-the-most-popular-apps-create",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-wallpapers.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-wallpapers-kawaii-wallpapers.webp",
        backgroundColor: "#2B2E40",
        color: '#fff',
        previewUrl: "/static/images/v3/1365817.webp",
        googlePlayUrl: "https://drive.google.com/file/d/134-PjZmrFXPmvmWYNiK9B20DsoqndL11/view?usp=sharing",
        layoutsId: 2809905
      },
      {
        isShowBtn: true,
        title: "easyStart.wallpapers.wall-px",
        description: "easyStart.one-of-the-most-popular-apps-create",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-wallpapers.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-wallpapers-wall-px.webp",
        backgroundColor: "#2B2E40",
        color: '#fff',
        previewUrl: "/static/images/v3/1269823.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1Kc8drJrPG25Q6Um5UDRviIfXDjiIxmUf/view?usp=sharing",
        layoutsId: 2809896
      }
    ],

    sounds: [
      {
        isShowBtn: true,
        title: "easyStart.sounds.ringtown",
        description: "easyStart.one-of-the-most-popular-apps-upload",
        componentList: [
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2900],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-music.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-sounds-ring-town.webp",
        backgroundColor: "#691A72",
        color: '#fff',
        previewUrl: "/static/images/v3/1189942.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1PZdMwDmZBK3WipG1vxRQ0Qy-MeNT8oQM/view?usp=sharing",
        layoutsId: 2809880
      },
      {
        isShowBtn: true,
        title: "easyStart.sounds.prank-sounds",
        description: "easyStart.one-of-the-most-popular-apps-upload",
        componentList: [
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-music.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-sounds-prank-sounds.webp",
        backgroundColor: "#691A72",
        color: '#fff',
        previewUrl: "/static/images/v3/1409018.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1tAZYPnaO0j5gJCLTDt9VP4RI9FQGoAmk/view?usp=sharing",
        layoutsId: 2809932
      },
      {
        isShowBtn: true,
        title: "easyStart.sounds.sounds-gallery",
        description: "easyStart.one-of-the-most-popular-apps-upload",
        componentList: [
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-music.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-sounds-sounds-gallery.webp",
        backgroundColor: "#691A72",
        color: '#fff',
        previewUrl: "/static/images/v3/1374718.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1BY-9aon5JakZIhgd6Vg3QHL3U-NXxQzG/view?usp=sharing",
        layoutsId: 2809929
      },
      {
        isShowBtn: true,
        title: "easyStart.sounds.jazz-radios",
        description: "easyStart.online-radio-in-your-pocket",
        componentList: [
          "activityCardsApp.audioPlayerOnline.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          // ["easyStart.up-to-monthly-income", 2000],
          // "easyStart.trending-in-google-play",
          // "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-music.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-wallpapers-wall-px.webp",
        backgroundColor: "#691A72",
        color: '#fff',
        previewUrl: "/static/images/v3/1860874.webp",
        googlePlayUrl: "https://drive.google.com/file/d/14w7LDJr2DI8xQ536ysZRPv892cFihsTO/view?usp=sharing",
        layoutsId: 2809989
      }
    ],

    recipes: [
      {
        isShowBtn: true,
        title: "easyStart.recipes.cookmaker",
        description: "easyStart.share-your-favourite-recipes",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-recipes.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-recipes-cookmaker.webp",
        backgroundColor: "#42332A",
        color: '#fff',
        previewUrl: "/static/images/v3/1191886.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1bGnMvULzXP1tTfTP3i2UlTgSGqWaayuW/view?usp=sharing",
        layoutsId: 2809901
      },
      {
        isShowBtn: true,
        title: "easyStart.recipes.keto-recipes",
        description: "easyStart.share-your-favourite-keto-reci",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-recipes.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-recipes-keto-recipes.webp",
        backgroundColor: "#42332A",
        color: '#fff',
        previewUrl: "/static/images/v3/1399442.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1BNKLZPNftTWOlavJXY9kLKvFoR1GKRPk/view?usp=sharing",
        layoutsId: 2809947
      },
      {
        isShowBtn: true,
        title: "easyStart.recipes.goveggie",
        description: "easyStart.share-your-favourite-vegan-rec",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 3000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-recipes.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-recipes-go-veggie.webp",
        backgroundColor: "#42332A",
        color: '#fff',
        previewUrl: "/static/images/v3/1459257.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1c5-qWXExOPSl0RGYMpYtUsyj8fU5FkfM/view?usp=sharing",
        layoutsId: 2809938
      }
    ],

    ebook: [
      {
        isShowBtn: true,
        title: "easyStart.ebook.bisbook",
        description: "easyStart.a-library-in-the-pocket-surpri",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-ebook.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-ebook-bisbook.webp",
        backgroundColor: "#0060D1",
        color: '#fff',
        previewUrl: "/static/images/v3/1191311.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1amDBNMo6Rt_zA2grm74iZ_rxp2xIytXa/view?usp=sharing",
        layoutsId: 2809921
      },
      {
        isShowBtn: true,
        title: "easyStart.ebook.tales-of-the-people-of-the-wor",
        description: "easyStart.a-library-in-the-pocket-surpri-2",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-ebook.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-ebook-tales-people-world.webp",
        backgroundColor: "#0060D1",
        color: '#fff',
        previewUrl: "/static/images/v3/1446370.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1YbgcDw8kIWZG95uIYwvuJmUdL3GBLEyw/view?usp=sharing",
        layoutsId: 2809955
      },
      {
        isShowBtn: true,
        title: "easyStart.ebook.ebooker",
        description: "easyStart.a-library-in-the-pocket-surpri-3",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-ebook.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-ebook-ebooker.webp",
        backgroundColor: "#0060D1",
        color: '#fff',
        previewUrl: "/static/images/v3/1384995.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1u7SudmqY-zGPuWeb7pQZQNFf8YNOywjo/view?usp=sharing",
        layoutsId: 2809952
      }
    ],

    fashion: [
      {
        isShowBtn: true,
        title: "easyStart.fashion.world-of-fashion-and-beauty",
        description: "easyStart.share-your-view-from-the-world",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.customPage.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-fashion.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-fashion-world-fashion-beauty.webp",
        backgroundColor: "#000000",
        color: '#fff',
        previewUrl: "/static/images/v3/1205901.webp",
        googlePlayUrl: "https://drive.google.com/file/d/12d-ovtpfYicBZccq0tNaZZ-ZvN8nuUwY/view?usp=sharing",
        layoutsId: 2809899
      },
      {
        isShowBtn: true,
        title: "easyStart.fashion.beauty-blogger",
        description: "easyStart.share-your-view-from-the-world",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.customPage.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1200],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-fashion.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-fashion-beauty-blogger.webp",
        backgroundColor: "#000000",
        color: '#fff',
        previewUrl: "/static/images/v3/1403244.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1TxYnPZJ7NE76LbOR9AY7yWRNAkjaaKBU/view?usp=sharing",
        layoutsId: 2552111
      },
      {
        isShowBtn: true,
        title: "easyStart.fashion.self-care-tips",
        description: "easyStart.an-app-that-helps-users-taking",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.customPage.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1800],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-fashion.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-fashion-self-care-tips.webp",
        backgroundColor: "#000000",
        color: '#fff',
        previewUrl: "/static/images/v3/1397523.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1S84MWpFB3fK0BHEkmouxVIKLQAEtQN3V/view?usp=sharing",
        layoutsId: 2810003
      }
    ],

    inspire: [
      {
        isShowBtn: true,
        title: "easyStart.inspire.inspirefly",
        description: "easyStart.inspire-your-users-with-quotes",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.rss.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-inspire.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-inspire-inspire-fly.webp",
        backgroundColor: "#25B995",
        color: '#fff',
        previewUrl: "/static/images/v3/1212939.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1mLmpWlVzrfz1LFUcbpSDDXFhr5HsGIOw/view?usp=sharing",
        layoutsId: 2809909
      },
      {
        isShowBtn: true,
        title: "easyStart.inspire.daily-affirmations",
        description: "easyStart.inspiration-and-positive-vibra",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.rss.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-inspire.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-inspire-daily-affirmations.webp",
        backgroundColor: "#25B995",
        color: '#fff',
        previewUrl: "/static/images/v3/1385135.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1-3sCB1tAL7Ay3Or2he0jkVZhNHoXOx9n/view?usp=sharing",
        layoutsId: 2809969
      },
      {
        isShowBtn: true,
        title: "easyStart.inspire.wisdom-of-zen",
        description: "easyStart.awaken-your-users-with-zen-sto",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.rss.title",
          "activityCardsApp.audioPlayer.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 5000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-inspire.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-inspire-wisdom-zen.webp",
        backgroundColor: "#25B995",
        color: '#fff',
        previewUrl: "/static/images/v3/1442237.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1DVt6WP9ziY_yP89F45BuymiGuSbGTghy/view?usp=sharing",
        layoutsId: 2809991
      }
    ],

    news: [
      {
        isShowBtn: true,
        title: "easyStart.news.good-news",
        description: "easyStart.combine-top-news-platforms-in-",
        componentList: [
          "activityCardsApp.rss.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1300],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-news.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-news-good-news.webp",
        backgroundColor: "#711B00",
        color: '#fff',
        previewUrl: "/static/images/v3/1195201.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1yTKZlBXGQE8BPUllIqhTBmimsaF523L5/view?usp=sharing",
        layoutsId: 2809942
      },
      {
        isShowBtn: true,
        title: "easyStart.news.crypto-news",
        description: "easyStart.combine-top-crypto-news-platfo",
        componentList: [
          "activityCardsApp.rss.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-news.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-news-crypto-news.webp",
        backgroundColor: "#711B00",
        color: '#fff',
        previewUrl: "/static/images/v3/1390611.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1hPPtaKUK9ryI6sD2DUUrp_u9qHME4SXd/view?usp=sharing",
        layoutsId: 2809994
      },
      {
        isShowBtn: true,
        title: "easyStart.news.tech-news",
        description: "easyStart.combine-top-tech-news-platform",
        componentList: [
          "activityCardsApp.rss.title",
          "activityCardsApp.nativeAdCard.title",
          "activityCardsApp.linkCard.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 1500],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-news.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-news-tech-news.webp",
        backgroundColor: "#711B00",
        color: '#fff',
        previewUrl: "/static/images/v3/1423927.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1qIwoOn1wB5Y5Z-FxqMWign3tFuP_TF9p/view?usp=sharing",
        layoutsId: 2810000
      }
    ],

    spiritual: [
      {
        isShowBtn: true,
        title: "easyStart.spiritual.spiritual-app",
        description: "easyStart.create-an-app-for-your-religio",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-spiritual.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-spiritual-spiritual-app.webp",
        backgroundColor: "#D5E3EB",
        color: '#00698A',
        previewUrl: "/static/images/v3/1215890.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1SW7KNZJzhK-DTA0qJE97KuWtNrbp1boe/view?usp=sharing",
        layoutsId: 2809919
      },
      {
        isShowBtn: true,
        title: "easyStart.spiritual.mindfulness-app",
        description: "easyStart.an-app-for-calming-relaxing-an",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-spiritual.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-spiritual-mindfullness-app.webp",
        backgroundColor: "#D5E3EB",
        color: '#00698A',
        previewUrl: "/static/images/v3/1372556.webp",
        googlePlayUrl: "https://drive.google.com/file/d/12ovweg_br5mfxubpYRzw-Qc6NKzHI9oQ/view?usp=sharing",
        layoutsId: 1463088
      },
      {
        isShowBtn: true,
        title: "easyStart.spiritual.your-church",
        description: "easyStart.create-an-app-for-your-religio-2",
        componentList: [
          "activityCardsApp.bookLibrary.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.photoGallery.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-spiritual.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-spiritual-your-church.webp",
        backgroundColor: "#D5E3EB",
        color: '#00698A',
        previewUrl: "/static/images/v3/1410936.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1k_0AtubrM2tjYC-ARLVf-kKxtn7SIn8C/view?usp=sharing",
        layoutsId: 2809985
      },
      {
        isShowBtn: true,
        title: "easyStart.spiritual.qibla-app",
        description: "easyStart.when-offering-namaz-all-muslim",
        componentList: [
          "activityCardsApp.qiblaActivity.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.audioPlayer.title"
        ],
        valueList: [
          "easyStart.find-qibla-location-anytime",
          "easyStart.this-location-is-fixed-as-the-"
        ],
        backgroundUrl: "/static/images/v3/background-app-spiritual.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-spiritual-qibla-app.png",
        backgroundColor: "#D5E3EB",
        color: '#00698A',
        previewUrl: "/static/images/v3/1589362.png",
        googlePlayUrl: "https://drive.google.com/file/d/1Efk1yYM1DnevkiyKll0b0WQSmqkSGvGv/view?usp=sharing",
        layoutsId: 2809950
      }
    ],

    education: [
      {
        isShowBtn: true,
        title: "easyStart.education.how-to-make-money-online-cours",
        description: "easyStart.promote-your-classes-attract-n",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-education.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-education-online-courses-app.webp",
        backgroundColor: "#EFBA00",
        color: '#000',
        previewUrl: "/static/images/v3/1228552.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1tcAonKjqXVUpBWlljRsFqUUtiVhxL6Yk/view?usp=sharing",
        layoutsId: 1475337
      },
      {
        isShowBtn: true,
        title: "easyStart.education.smm-education",
        description: "easyStart.promote-your-classes-attract-n",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-education.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-education-smm-education.webp",
        backgroundColor: "#EFBA00",
        color: '#000',
        previewUrl: "/static/images/v3/1377873.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1Fpk8u-vBVPBY21vds9xeywTGkq0Nryj1/view?usp=sharing",
        layoutsId: 2809931
      },
      {
        isShowBtn: true,
        title: "easyStart.education.your-school-app",
        description: "easyStart.effective-communication-betwee",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-education.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-education-your-school-app.webp",
        backgroundColor: "#EFBA00",
        color: '#000',
        previewUrl: "/static/images/v3/1409179.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1FfqHK5B9ROYgeL2ljT4SuLllOLQcMVwH/view?usp=sharing",
        layoutsId: 2809926
      }
    ],

    personal: [
      {
        isShowBtn: true,
        title: "easyStart.personal.personal-app-for-a-musician",
        description: "easyStart.make-your-personal-app-and-sha",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-for-merch-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-personal.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-personal-personal-musician.webp",
        backgroundColor: "#211748",
        color: '#fff',
        previewUrl: "/static/images/v3/1241166.webp",
        googlePlayUrl: "https://drive.google.com/file/d/18TJysEsIArZh4JZIE6Q__UYybwAVPNb9/view?usp=sharing",
        layoutsId: 1475587
      },
      {
        isShowBtn: true,
        title: "easyStart.personal.i-am-a-dj",
        description: "easyStart.make-your-personal-app-and-sha",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-for-merch-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-personal.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-personal-dj.webp",
        backgroundColor: "#211748",
        color: '#fff',
        previewUrl: "/static/images/v3/1426286.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1ICEc6Hqj6SLZicYtvRQDFngSjko4KI1Q/view?usp=sharing",
        layoutsId: 2809974
      },
      {
        isShowBtn: true,
        title: "easyStart.personal.i-am-a-photographer",
        description: "easyStart.make-your-personal-app-and-sha",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-for-merch-sales", 20],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexit"
        ],
        backgroundUrl: "/static/images/v3/background-app-personal.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-personal-photographer.webp",
        backgroundColor: "#211748",
        color: '#fff',
        previewUrl: "/static/images/v3/1388371.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1h8LByb5LU-bVX_M-F7eKL2-nxkjNgaqQ/view?usp=sharing",
        layoutsId: 2809972
      }
    ],

    smallbusiness: [
      {
        isShowBtn: true,
        title: "easyStart.smallbusiness.barbershop",
        description: "easyStart.expand-your-business-to-a-new-",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.contactCard.title",
          "activityCardsApp.social-networks.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-smallbusiness.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-smallbusiness-barbershop.webp",
        backgroundColor: "#55dde5",
        color: '#000',
        previewUrl: "/static/images/v3/1552036.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1mCS45jj-T0nQe0xwxKe8mSUMjSuRW3Wm/view?usp=sharing",
        layoutsId: 2809895
      },
      {
        isShowBtn: true,
        title: "easyStart.smallbusiness.massage-room",
        description: "easyStart.expand-your-business-to-a-new-",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.contactCard.title",
          "activityCardsApp.social-networks.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-smallbusiness.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-smallbusiness-massage-room.webp",
        backgroundColor: "#55dde5",
        color: '#000',
        previewUrl: "/static/images/v3/1555109.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1PJB-r2dsmWVNN6W-TLSeQb6vOBmS4zG8/view?usp=sharing",
        layoutsId: 2809944
      },
      {
        isShowBtn: true,
        title: "easyStart.smallbusiness.tattoo-studio",
        description: "easyStart.expand-your-business-to-a-new-",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.contactCard.title",
          "activityCardsApp.social-networks.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-smallbusiness.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-smallbusiness-tattoo-studio.webp",
        backgroundColor: "#55dde5",
        color: '#000',
        previewUrl: "/static/images/v3/1565448.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1ZSAAIDdUAnAfTQ3HWqRciLEO3_EM21JR/view?usp=sharing",
        layoutsId: 2809964
      },
      {
        isShowBtn: true,
        title: "easyStart.smallbusiness.real-estate-app",
        description: "easyStart.expand-your-business-to-a-new-",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.phoneCard.title",
          "activityCardsApp.rss.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-smallbusiness.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-smallbusiness-real-estate-app.webp",
        backgroundColor: "#55dde5",
        color: '#000',
        previewUrl: "/static/images/v3/1927792.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1P8jkOoTvnMLwLeFmNK1UaMYPhJvsEv_v/view?usp=sharing",
        layoutsId: 2809975
      },
      {
        isShowBtn: true,
        title: "easyStart.smallbusiness.the-royals-restaurant",
        description: "easyStart.expand-your-business-to-a-new-",
        componentList: [
          "activityCardsApp.pdfReader.title",
          "activityCardsApp.linkCard.title",
          "activityCardsApp.customPage.title",
          "activityCardsApp.photoGallery.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-smallbusiness.jpg",
        qrCodeImg: "/static/images/v3/qrcode/app-smallbusiness-the-royals-restaurant.webp",
        backgroundColor: "#55dde5",
        color: '#000',
        previewUrl: "/static/images/v3/1937080.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1xTxn9Jh8YHPdz72p9xUjZzbzDcR76I21/view?usp=sharing",
        layoutsId: 2809983
      }
    ],

    affiliate: [
      {
        isShowBtn: true,
        title: "easyStart.affiliate.how-to-earn-money-online",
        description: "easyStart.affiliate.attract-new-customers-become",
        componentList: [
          "activityCardsApp.customPage.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.paidAccessComponent.title"
        ],
        valueList: [
          ["easyStart.up-to-monthly-income", 2000],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/background-app-affiliate.webp",
        qrCodeImg: "/static/images/v3/qrcode/app-affiliate-earn-money.webp",
        backgroundColor: "#36E27B",
        color: '#000',
        previewUrl: "/static/images/v3/1691268.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1-IhHnSrGWZ5M2frgVUR7NXn3ODf9Rqr7/view?usp=sharing",
        layoutsId: 2809935
      }
    ],

    blankContentTemplate: [
      {
        isShowBtn: true,
        title: "easyStart.blankContentTemplate.title",
        description: "easyStart.blankContentTemplate.description",
        componentList: [
          "activityCardsApp.photoGallery.title",
          "activityCardsApp.audioPlayer.title",
          "activityCardsApp.youtube.title",
          "activityCardsApp.bookLibrary.title"
        ],
        valueList: [
        ],
        backgroundUrl: "/static/images/v3/2246668-background-blankContentTemplate.webp",
        qrCodeImg: "/static/images/v3/qrcode/blank-content-template-2246668.webp",
        backgroundColor: "#2773FF",
        color: '#fff',
        previewUrl: "/static/images/v3/2246668-preview-blankContentTemplate.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1ron7wAhCl76b2GLAWVyHA0TsTxW_tjGk/view?usp=sharing",
        layoutsId: 2809903
      }
    ]
      
  },

  ecommerce: {
    shopifyClothingShop:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyClothingShop.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2139037-background-shopifyClothingShop.webp",
        qrCodeImg: "/static/images/v3/qrcode/shopify-clothing-shop-2139037.webp",
        backgroundColor: "#1A1423",
        color: '#fff',
        previewUrl: "/static/images/v3/2139037-preview-shopifyClothingShop.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1yqEsMZ1AECgfQLyLNehEo2tT16pe_SMe/view?usp=sharing",
        layoutsId: 2809906
      }
    ],
    shopifyToysStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyToysStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2151599-background-shopifyToysStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/shopify-toys-store-2151599.webp",
        backgroundColor: "#620CA5",
        color: '#fff',
        previewUrl: "/static/images/v3/2151599-preview-shopifyToysStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1XpxoSTqAtBDOj5rCsF-z_FuGgJ7V3oFq/view?usp=sharing",
        layoutsId: 2809925
      }
    ],
    shopifySportsStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifySportsStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2130384-background-shopifySportsStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/shopify-sports-store-2130384.webp",
        backgroundColor: "#BE56CF",
        color: '#fff',
        previewUrl: "/static/images/v3/2130384-preview-shopifySportsStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1SI1V2WnmIMkcOxCTovBlPgj0z2kRwn1Z/view?usp=sharing",
        layoutsId: 2809924
      }
    ],
    shopifyFurnitureStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyFurnitureStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2249208-background-shopifyFurnitureStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/2249208-qrcode-shopifyFurnitureStore.webp",
        backgroundColor: "#F5AE10",
        color: '#000',
        previewUrl: "/static/images/v3/2249208-preview-shopifyFurnitureStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1_vOe6cIwt96KaYyudmA_hleppa1f2yqn/view?usp=sharing",
        layoutsId: 2809958
      }
    ],
    shopifyHandcraftsStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyHandcraftsStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2281188-background-shopifyHandcraftsStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/2281188-qrcode-shopifyHandcraftsStore.webp",
        backgroundColor: "#E29A63",
        color: '#fff',
        previewUrl: "/static/images/v3/2281188-preview-shopifyHandcraftsStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1SEFYh8OJjo9LKKPBWpyZZKuAu8mr43Vk/view?usp=sharing",
        layoutsId: 2809960
      }
    ],
    shopifyBeautyStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyBeautyStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2335542-background-shopifyBeautyStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/2335542-qrcode-shopifyBeautyStore.webp",
        backgroundColor: "#B2B8A9",
        color: '#000',
        previewUrl: "/static/images/v3/2335542-preview-shopifyBeautyStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1RhIuVVfbQX0KZxV6tGY_mTLUWlRlGqpK/view?usp=sharing",
        layoutsId: 2809977
      }
    ],
    shopifyGroceriesStore:[
      {
        isShowBtn: true,
        title: "easyStart.shopifyGroceriesStore.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2863112-background-shopifyGroceriesStore.webp",
        qrCodeImg: "/static/images/v3/qrcode/2863112-qrcode-shopifyGroceriesStore.webp",
        backgroundColor: "#A17002",
        color: '#fff',
        previewUrl: "/static/images/v3/2863112-preview-shopifyGroceriesStore.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1r13Oi6Cz7fQVge89mMvfQxH4CQe_b8Ak/view?usp=sharing",
        layoutsId: 2863112
      }
    ],
    jewelryStoreTemplate: [
      {
        isShowBtn: true,
        title: "easyStart.jewelryStoreTemplate.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
          ["easyStart.up-to-sales", 25],
          "easyStart.trending-in-google-play",
          "easyStart.beginner-complexity"
        ],
        backgroundUrl: "/static/images/v3/2466880-background-shopifyJewelryStoreTemplate.webp",
        qrCodeImg: "/static/images/v3/qrcode/2466880-qrcode-shopifyJewelryStoreTemplate.webp",
        backgroundColor: "#121213",
        color: '#fff',
        previewUrl: "/static/images/v3/2466880-preview-shopifyJewelryStoreTemplate.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1UpZ7hCcQwROIlzBmjFPErOM--8aQAu-3/view?usp=sharing",
        layoutsId: 3792691
      }
    ],
    WoocommerceTemplate: [
      {
        isShowBtn: true,
        title: "easyStart.WoocommerceTemplate.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
        ],
        backgroundUrl: "/static/images/v3/2244376-background-blankEcommerceTemplate.webp",
        qrCodeImg: "/static/images/v3/qrcode/blank-ecommerce-template-4080328.webp",
        backgroundColor: "#6C29FF",
        color: '#fff',
        previewUrl: "/static/images/v3/4080328-preview-blankEcommerceTemplate.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1EH51XOAm1q5ytutX1zter9y4XZkfk5WM/view?usp=sharing",
        layoutsId: 4080328
      }
    ],
    blankEcommerceTemplate: [
      {
        isShowBtn: true,
        title: "easyStart.blankEcommerceTemplate.title",
        description: "easyStart.shopify.shopify-description",
        componentList: [
          "activityCardsApp.shopifyCart.title",
          "activityCardsApp.shopifyProfile.title",
          "activityCardsApp.shopifyCollection.title",
          "activityCardsApp.shopifyProduct.title"
        ],
        valueList: [
        ],
        backgroundUrl: "/static/images/v3/2244376-background-blankEcommerceTemplate.webp",
        qrCodeImg: "/static/images/v3/qrcode/blank-ecommerce-template-2244376.webp",
        backgroundColor: "#6C29FF",
        color: '#fff',
        previewUrl: "/static/images/v3/2244376-preview-blankEcommerceTemplate.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1zfc6HzCjXi7rk68wYsJ4OWb2TV_yqJDJ/view?usp=sharing",
        layoutsId: 2809971
      }
    ]
  },
  gamesApp: {
    candyMatchSaga: [
      {
        isShowBtn: true,
        title: "activityCardsApp.candyMatchSaga2.title",
        description: "activityCardsApp.candyMatchSaga2.desc",
        componentList: [
          "activityCardsApp.candyMatchSaga2.tooltip"
        ],
        valueList: [
        ],
        backgroundUrl: "/static/images/v3/candyMatchSaga-background.webp",
        qrCodeImg: "/static/images/v3/qrcode/candyMatchSaga-qrcode.webp",
        backgroundColor: "#8476E4",
        color: '#fff',
        previewUrl: "/static/images/v3/candyMatchSaga-preview.webp",
        googlePlayUrl: "https://drive.google.com/file/d/1OmS6g7vQYJE3cLx4aByYhmV-LB2akUTd/view?usp=sharing",
        layoutsId: 3574884
      }
    ]
  }

};
